<template>
  <div id="header-wrapper">
    <header>
      <el-row type="flex" align="middle" justify="space-between" id="nav-row">
        <el-col id="nav-col-left">
          <div class="nav-wrapper">
            <img src="../assets/logo_new.png" width="180px" />
          </div>
        </el-col>
        <el-col id="nav-col-right">
          <!--<div style="display: inline-block;">-->
          <!--<el-button @click="killToken">-->
          <!--Kill token-->
          <!--</el-button>-->
          <!--</div>-->
          <div
            class="nav-wrapper info-text"
            v-if="user.isLoggedIn && production && production.name && $route.path !== '/login'"
          >
            {{ production.name || "" }}
          </div>
          <div
            class="nav-wrapper info-text"
            v-else-if="user.isLoggedIn && company && company.name && $route.path !== '/login'"
          >
            {{ company.name || "" }}
          </div>
          <div
            class="nav-wrapper info-text"
            v-else-if="user.isLoggedIn && !availableInstances.length && $route.path !== '/login'"
          >
            {{ activeInstance.url || "" }}
          </div>
          <div class="nav-wrapper" v-if="$route.path !== '/login'">
            <el-menu
              theme="dark"
              class="el-menu-demo"
              mode="horizontal"
              menu-trigger="click"
            >
              <el-menu-item
                index="1"
                v-if="!user.isLoggedIn && $route.path !== '/login'"
              >
                <router-link to="/login">Login</router-link>
              </el-menu-item>
              <el-submenu
                v-if="user.isLoggedIn && availableInstances.length"
                index="2"
                class="nav-item"
              >
                <template slot="title">
                  {{ activeInstance.name || activeInstance.url }}
                </template>
                <el-menu-item
                  v-for="app in sortedInstances"
                  :key="app.url"
                  @click="checkIfReAuthNeeded(app.url)"
                  class="nav-menu-item"
                  index="1-1"
                >
                  {{ app.name || app.url }}
                </el-menu-item>
                <el-menu-item
                  @click="addInstance"
                  class="nav-menu-item"
                  index="1-2"
                >
                  Sign in to new instance
                </el-menu-item>
              </el-submenu>
              <el-submenu index="3" v-if="user.isLoggedIn" class="nav-item">
                <template slot="title">{{ user.username }}</template>
                <el-menu-item class="nav-menu-item" index="2-1" @click="goToChangePassword()">
                  Change Password
                </el-menu-item>
                <el-menu-item
                  class="nav-menu-item"
                  index="2-1"
                  @click="logout()"
                >
                  Logout
                </el-menu-item>
                <!--                <el-menu-item v-if="!availableInstances.length" class="nav-menu-item" index="2-2" @click="addInstance">-->
                <!--                  Sign into new instance-->
                <!--                </el-menu-item>-->
              </el-submenu>
            </el-menu>
            <div class="line"></div>
          </div>
          <div class="nav-wrapper info-text"
            >
            <a href="https://help.revolutiones.com/en/collections/3555235-probooks" target="_blank">Help</a>
          </div>
        </el-col>
      </el-row>
    </header>
    <ReAuthModal
      v-if="user.isLoggedIn"
      :url="url"
      @reauthSuccess="switchAppInstance"
    ></ReAuthModal>
    <AuthModal
      v-if="user.isLoggedIn"
      @authSuccess="switchAppInstance"
    ></AuthModal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ReAuthModal from '@/components/ReAuthModal.vue'
import AuthModal from '@/components/AuthModal.vue'

export default {
  name: 'header',
  components: { ReAuthModal, AuthModal },
  data () {
    return {
      reAuthSuccess: false,
      url: ''
    }
  },
  methods: {
    /**
     * Method for testing with invalid token
     */
    killToken () {
      this.$store.dispatch('sabotageToken')
    },
    /**
     * Triggers logout procedure
     */
    async logout () {
      try {
        await this.$store.dispatch('logout')
        this.$router.push('/login')
      } catch (e) {
        console.log(e)
      }
    },
    async goToChangePassword () {
      this.$router.push('/change_password')
    },
    /**
     * Checks if authentication is needed to switch app instances
     */
    checkIfReAuthNeeded (url) {
      const targetApp = this.instances.find((v) => v.url === url)
      if (!targetApp.token || this.checkIfTokenIsExpired(targetApp)) {
        this.url = targetApp.url
        this.$store.dispatch('changeModalVisibility', {
          entityType: 'reauthModal',
          visible: true
        })
      } else {
        this.url = ''
        this.$store.dispatch('changeModalVisibility', {
          entityType: 'reauthModal',
          visible: false
        })
        this.switchAppInstance(targetApp.url)
      }
    },
    /**
     * Checks if an app instance's token is expired
     * @param targetApp   Target app instance
     */
    checkIfTokenIsExpired (targetApp) {
      return targetApp.token && Math.round(Date.now() / 1000) >= targetApp.exp
    },
    /**
     * Allows a user to switch between app instances. Clears the store (except for auth state), fetches settings,
     * and reloads data for the new instance. If the user is already in the posting program, fetches new data;
     * otherwise, routes the user to the posting program.
     * @param url    The url of the instance to switch to
     */
    async switchAppInstance (url) {
      try {
        const instance = this.instances.find((v) => v.url === url)
        if (instance) {
          await this.$store.dispatch('clearState')
          await this.$store.dispatch('switchActiveAppInstance', instance)
          await this.$store.dispatch('fetchUiSetting', { name: 'AR_ENABLED' })
          await this.$store.dispatch('fetchUiSetting', { name: 'TRANSACTION_ENTRY_OPTIONS' })
          await this.$store.dispatch('fetchUiSetting', {
            name: 'PAYROLL_ENABLED'
          })
          await this.$store.dispatch('fetchUiSetting', {
            name: 'TRIAL_BALANCE_REPORT_DEFAULT_SETTINGS'
          })
          await this.$store.dispatch('fetchUiSetting', {
            name: 'GL_REPORT_DEFAULT_SETTINGS'
          })
          await this.$store.dispatch('fetchHomePageTextUiSetting')

          await this.$parent.loadData()
          if (this.$route.name === 'Home') {
            this.$root.$emit('reloadHomeData')
          }
          this.$router.push({ name: 'Home' })
        }
      } catch (e) {
        console.log(e)
      }
    },
    addInstance () {
      this.$store.dispatch('changeModalVisibility', {
        entityType: 'authModal',
        visible: true
      })
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      instances: 'getInstances',
      production: 'getDefaultProduction',
      company: 'getDefaultCompany',
      activeInstance: 'getActiveInstance',
      availableInstances: 'getAvailableInstances',
      loading: 'getSwitchingActiveAppInstanceStatus',
      getReauthStatus: 'getReauthStatus',
      transactions: 'getTransactionsToBePosted'
    }),
    sortedInstances () {
      if (!this.availableInstances || !this.availableInstances.length) return []
      return this.availableInstances.slice().sort((a, b) => {
        if (a.name && b.name) {
          return a.name.localeCompare(b.name)
        } else if (a.name && !b.name) {
          return -1
        } else if (!a.name && b.name) {
          return 1
        } else {
          return a.url.localeCompare(b.url)
        }
      })
    }
  },
  watch: {
    // activeInstance () {
    //   if (this.user.isLoggedIn) {
    //     this.$store.dispatch('clearProductionState')
    //     this.$store.dispatch('fetchProductionsWithQuery', null)
    //   }
    // }
  }
}
</script>

<style scoped>
.info-text {
  color: #000;
  font-size: 14px;
  line-height: 35px;
}
#header-wrapper {
  background: #fff;
  padding: 5px 0;
  border-bottom-width: 12px;
  border-bottom-style: solid;
  border-image: linear-gradient(135deg, #55d9a3 0%, #006a9c 100%);
  border-image-slice: 1;
}
#nav-row {
  padding: 0 12px;
  height: 40px;
}
#nav-col-left {
  text-align: left;
}
#nav-col-left h1 {
  margin: 0;
  font-family: "Roboto Condensed", "Helvetica", Arial, sans-serif;
}
#nav-col-right {
  text-align: right;
}
header .el-submenu__title {
  color: #fff !important;
}
.nav-wrapper {
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
}
.nav-wrapper img {
  vertical-align: middle;
}
.nav-wrapper:nth-of-type(2) {
  padding: 0 6px;
}
header {
  vertical-align: middle;
  color: #fff;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  position: relative;
}
.nav-item {
  padding: 0 12px;
}
.nav-menu-item {
  text-align: center;
}
.el-menu--dark .el-menu-item,
.el-menu--dark .el-submenu__title {
  color: #000 !important;
}
</style>
<style>
#nav-col-right .el-menu--dark .el-menu-item,
#nav-col-right .el-menu--dark .el-submenu__title {
  color: #000 !important;
}
.el-menu--horizontal > .el-menu-item:hover,
.el-menu--horizontal > .el-submenu.is-active .el-submenu__title,
.el-menu--horizontal > .el-submenu:hover .el-submenu__title {
  border-bottom: 5px solid #22909f !important;
}
</style>


// WEBPACK FOOTER //
// src/layouts/Header.vue